import React from 'react';
import { Link } from 'react-router-dom';

// Build version: MMDD.HHMMSS format (update before each deploy)
// See CLAUDE.md for versioning documentation
const BUILD_VERSION = '0927.185128';

// TODO: Fill in the real profile URLs once the social accounts are claimed, then
// remove the display:none below. Add the same URLs to the Organization JSON-LD
// "sameAs" in public/index.html only once they are live and verified.
const SOCIAL_LINKS = [
  { label: 'Facebook', icon: 'fab fa-facebook', url: '' },
  { label: 'Twitter', icon: 'fab fa-twitter', url: '' },
  { label: 'Instagram', icon: 'fab fa-instagram', url: '' },
  { label: 'LinkedIn', icon: 'fab fa-linkedin', url: '' },
];

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-light" style={{paddingBottom: 0, marginTop: 0}}>
      <div className="container">
        <div className="row">
          <div className="col-md-8 mb-4 mb-md-0">
            <img
              src="/assets/images/StampOutSuicide.png"
              alt="StampOutSuicide.org"
              className="footer-logo mb-3"
              width={512}
              height={312}
            />
            <p className="text-muted">
              Sharing uplifting messages and creating positive impact in communities around the world.
            </p>
            {/* Hidden until the accounts exist; see SOCIAL_LINKS above. */}
            <div className="social-links" style={{display: 'none'}}>
              {SOCIAL_LINKS.filter((link) => link.url).map((link) => (
                <a key={link.label} href={link.url} className="me-3 text-decoration-none" aria-label={link.label}>
                  <i className={link.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="col-md-4 mb-3 mb-md-0">
            <h6 className="mb-3">Quick Links</h6>
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                <Link to="/" className="text-decoration-none text-muted">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/notes" className="text-decoration-none text-muted">Browse Notes</Link>
              </li>
              {/* TODO: Create About Us page */}
              <li className="mb-2" style={{display: 'none'}}>
                <Link to="/about" className="text-decoration-none text-muted">About Us</Link>
              </li>
              {/* TODO: Create Contact page */}
              <li className="mb-2" style={{display: 'none'}}>
                <Link to="/contact" className="text-decoration-none text-muted">Contact</Link>
              </li>
            </ul>
          </div>

          {/* TODO: Create Contributors, Display Locations, Our Impact, and Volunteer pages */}
          <div className="col-md-2 col-6 mb-3 mb-md-0" style={{display: 'none'}}>
            <h6 className="mb-3">Community</h6>
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                <Link to="/contributors" className="text-decoration-none text-muted">Contributors</Link>
              </li>
              <li className="mb-2">
                <Link to="/displays" className="text-decoration-none text-muted">Display Locations</Link>
              </li>
              <li className="mb-2">
                <Link to="/impact" className="text-decoration-none text-muted">Our Impact</Link>
              </li>
              <li className="mb-2">
                <Link to="/volunteer" className="text-decoration-none text-muted">Volunteer</Link>
              </li>
            </ul>
          </div>

          {/* TODO: Create newsletter subscription functionality */}
          <div className="col-md-4" style={{display: 'none'}}>
            <h6 className="mb-3">Newsletter</h6>
            <p className="text-muted mb-3">Stay updated with our latest news and inspirational content.</p>
            <form className="d-flex">
              <input
                type="email"
                className="form-control me-2"
                placeholder="Your email address"
                aria-label="Email address for newsletter"
              />
              <button className="btn btn-secondary" type="submit">Subscribe</button>
            </form>
          </div>
        </div>
        
        <hr className="my-4" />

        <div className="row align-items-center mb-3">
          <div className="col-md-12 text-center small">
            <p className="text-muted mb-1">
              <strong>Public Relations Contact:</strong> Kris Cottrell
            </p>
            <p className="text-muted mb-0">
              <a href="mailto:pr@stampoutsuicide.org" className="text-decoration-none text-muted">
                pr@stampoutsuicide.org
              </a>
            </p>
          </div>
        </div>

        <div className="row align-items-center" style={{marginBottom: 0}}>
          <div className="col-md-6 small text-center text-md-start" style={{marginBottom: 0}}>
            <span className="text-muted">&copy; {currentYear} StampOutSuicide.org. All Rights Reserved.</span>
          </div>
          <div className="col-md-6 text-center text-md-end small">
            <Link to="/privacy" className="text-decoration-none text-muted me-3">Privacy Policy</Link>
            {/* TODO: Create Terms of Use and Cookie Policy pages */}
          </div>
        </div>
        {/* Build version indicator for deployment verification */}
        <div className="text-start" style={{ marginTop: '0.5rem', marginBottom: '0.25rem' }}>
          <span style={{ fontSize: '0.65rem', color: 'rgba(0, 0, 0, 0.55)' }}>v{BUILD_VERSION}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 